import axios from "axios";

const axiosInstance = axios.create({
    baseURL: 'rest/perspective/',         
    headers: {
        'Access-Control-Allow-Origin' : '*',
    }
});

export const getPerspectives = () => {
    return axiosInstance.get('');
}
